module.exports = __webpack_public_path__ + "img/logo-shopify.eaf1b9d2.png";